import { AntragHelperService } from '../../antrags-overview/antrag-helper.service';
import { Pipe, PipeTransform, inject } from '@angular/core';

@Pipe({
  name: 'statusToI18n',
})
export class StatusToI18nPipe implements PipeTransform {
  public antragsHelper: AntragHelperService = inject(AntragHelperService);

  public transform(value: string): string {
    return this.antragsHelper.getStateI18nKey(value);
  }
}
